<div class="row">
  <div class="col" style="flex: 3">
    <span [class.isDifferent]="isModifierNameDifferent()">
      {{ getProductName(modifierProduct.modifierId) }}
    </span>
  </div>
  <div class="col" *ngIf="modifierGroup.childModifiersHaveMinMaxRestrictions">
    <span *ngIf="!isEditingMode; else minInput" [class.isDifferent]="isModifierMinDifferent()">
      {{ initValues.min  }}
    </span>
    <ng-template #minInput>
      <input [(ngModel)]="modifierMin"
             class="modifier-input input-number"
             [class.isDifferent]="isModifierMinInputDifferent()"
             min="0"
             type="number"
             [readonly]="!allowOverrides"
             (blur)="onChangeInformationMessage()">
    </ng-template>
  </div>
  <div class="col">
    <span *ngIf="!isEditingMode; else defaultAmount" [class.isDifferent]="isModifierDefaultAmountDifferent()">
      {{ initValues.defaultAmount }}
    </span>
    <ng-template #defaultAmount>
      <input [(ngModel)]="modifierDefaultAmount"
             class="modifier-input input-number"
             [class.isDifferent]="isModifierDefaultAmountDifferent()"
             min="0"
             max="{{modifierMax}}"
             type="number"
             [readonly]="!allowOverrides"
             (blur)="onChangeInformationMessage()">
    </ng-template>
  </div>
  <div class="col" *ngIf="modifierGroup.childModifiersHaveMinMaxRestrictions">
    <span *ngIf="!isEditingMode; else maxInput" [class.isDifferent]="isModifierMaxDifferent()">
      {{ initValues.max }}
    </span>
    <ng-template #maxInput>
      <input [(ngModel)]="modifierMax"
             class="modifier-input input-number"
             [class.isDifferent]="isModifierMaxInputDifferent()"
             min="0"
             type="number"
             [readonly]="!allowOverrides"
             (blur)="onChangeInformationMessage()">
    </ng-template>
  </div>
  <div class="col" *ngIf="modifierGroup.childModifiersHaveMinMaxRestrictions">
    <span *ngIf="!isEditingMode; else freeQuantityInput" [class.isDifferent]="isModifierFreeQuantityDifferent()">
      {{ initValues.freeQuantity }}
    </span>
    <ng-template #freeQuantityInput>
      <input [(ngModel)]="modifierFreeQuantity"
             class="modifier-input input-number"
             [class.isDifferent]="isModifierFreeQuantityInputDifferent()"
             min="0"
             max="{{modifierMax}}"
             type="number"
             [readonly]="!allowOverrides"
             (blur)="onChangeInformationMessage()">
    </ng-template>
  </div>
  <div class="col">
    <span>
      {{ getProductPrice(modifierProduct.modifierId) }} {{ currency }}
    </span>
  </div>
  <div class="col">
    <mat-checkbox
      [(ngModel)]="isHidden"
      name="isHidden"
      ngDefaultControl
      type="checkbox"
      [disabled]="!isEditingMode || !allowOverrides">
    </mat-checkbox>
  </div>
  <div class="col">
    <mat-icon
      *ngIf="allowOverrides && !isBeingSaveProcessed"
      (click)="editModifier()"
      [class]="{'edit-icon': true, 'edit-hidden': isEditHidden()}"
      color="primary"
      matTooltip="{{ editModifierIconTooltip }}"
      matTooltipPosition="above">{{ isEditingMode ? 'save' : 'iso' }}
    </mat-icon>

    <mat-icon
      *ngIf="allowOverrides && !isBeingSaveProcessed"
      (click)="editProduct()"
      class="edit-icon"
      color="primary"
      matTooltip="{{ editProductIconTooltip }}"
      matTooltipPosition="above">{{ 'edit' }}
    </mat-icon>

    <mat-icon *ngIf="isBeingSaveProcessed">data_usage</mat-icon>

  </div>
</div>
